import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeAngel: [
    {
      id: 1,
      angelName: "James Whitaker",
      email: "james@gmail.com",
      industry: ["AI_MACHINE_LEARNING", "SOCIAL_NETWORKING"],
      startupStage: ["IDEA",],
      plan: 'Yearly Plan',
      dateRegistered: "May 2, 2024",
      lastActive: "May 2, 2024"
    },
    {
      id: 2,
      angelName: "Olivia Hastings",
      email: "olivia@gmail.com",
      industry: ["SOCIAL_NETWORKING", "AI_MACHINE_LEARNING"],
      startupStage: ["MVP",],
      plan: 'Monthly Plan',
      dateRegistered: "May 3, 2024",
      lastActive: "May 3, 2024"
    },
    {
      id: 3,
      angelName: "Brandon Cole",
      email: "brandon@gmail.com",
      industry: ["CYBERSECURITY"],
      startupStage: ["MVP",],
      plan: 'Monthly Plan',
      dateRegistered: "April 29, 2024",
      lastActive: "April 29, 2024"
    },
    {
      id: 4,
      angelName: "Sophia Klein",
      email: "sophia@gmail.com",
      industry: ["AI_MACHINE_LEARNING", 'CYBERSECURITY'],
      startupStage: ["PRE_SEED",],
      plan: 'Yearly Plan',
      dateRegistered: "April 17, 2024",
      lastActive: "April 17, 2024"
    },
    {
      id: 5,
      angelName: "Ethan Morales",
      email: "ethan@gmail.com",
      industry: ["TRANSPORT_MOBILITY", "CYBERSECURITY", 'AI_MACHINE_LEARNING'],
      startupStage: ["IDEA",],
      plan: 'Monthly Plan',
      dateRegistered: "May 16, 2024",
      lastActive: "May 16, 2024"
    },
    {
      id: 6,
      angelName: "Madison Lee",
      email: "madison@gmail.com",
      industry: ["E_COMMERCE_RETAIL"],
      startupStage: ["MVP", "SERIES_A"],
      plan: 'Monthly Plan',
      dateRegistered: "June 1, 2024",
      lastActive: "June 1, 2024"
    },
    {
      id: 7,
      angelName: "Dylan Prescott",
      email: "dylan@gmail.com",
      industry: ["CYBERSECURITY"],
      startupStage: ["SERIES_A", "MVP", "SERIES_B"],
      plan: 'Yearly Plan',
      dateRegistered: "April 17, 2024",
      lastActive: "April 17, 2024"
    },
    {
      id: 8,
      angelName: "Isabella Novak",
      email: "isabella@gmail.com",
      industry: ["GAMING_ENTERTAINMENT"],
      startupStage: ["SERIES_B",],
      plan: 'Monthly Plan',
      dateRegistered: "April 21, 2024",
      lastActive: "April 21, 2024"
    },
    {
      id: 9,
      angelName: "Marcus Bell",
      email: "marcus@gmail.com",
      industry: ["HEALTH_BIOTECH"],
      startupStage: ["PRE_SEED",],
      plan: 'Monthly Plan',
      dateRegistered: "April 29, 2024",
      lastActive: "April 29, 2024"
    },
    {
      id: 10,
      angelName: "Chloe Ramsey",
      email: "chloe@gmail.com",
      industry: ["AI_MACHINE_LEARNING"],
      startupStage: ["IDEA",],
      plan: 'Monthly Plan',
      dateRegistered: "July 13, 2024",
      lastActive: "July 13, 2024"
    }
  ],
  notCompletedAngel: [
    {
      id: 1,
      angelName: "James Whitaker",
      email: "james@gmail.com",
      industry: ["AI_MACHINE_LEARNING", "SOCIAL_NETWORKING"],
      startupStage: ["IDEA",],
      plan: 'Yearly Plan',
      dateRegistered: "May 2, 2024",
      lastActive: "May 2, 2024"
    },
    {
      id: 2,
      angelName: "Olivia Hastings",
      email: "olivia@gmail.com",
      industry: ["SOCIAL_NETWORKING", "AI_MACHINE_LEARNING"],
      startupStage: ["MVP",],
      plan: 'Monthly Plan',
      dateRegistered: "May 3, 2024",
      lastActive: "May 3, 2024"
    },
    {
      id: 3,
      angelName: "Brandon Cole",
      email: "brandon@gmail.com",
      industry: ["CYBERSECURITY"],
      startupStage: ["MVP",],
      plan: 'Monthly Plan',
      dateRegistered: "April 29, 2024",
      lastActive: "April 29, 2024"
    },
    {
      id: 4,
      angelName: "Sophia Klein",
      email: "sophia@gmail.com",
      industry: ["AI_MACHINE_LEARNING", 'CYBERSECURITY'],
      startupStage: ["PRE_SEED",],
      plan: 'Yearly Plan',
      dateRegistered: "April 17, 2024",
      lastActive: "April 17, 2024"
    },
    {
      id: 5,
      angelName: "Ethan Morales",
      email: "ethan@gmail.com",
      industry: ["TRANSPORT_MOBILITY", "CYBERSECURITY", 'AI_MACHINE_LEARNING'],
      startupStage: ["IDEA",],
      plan: 'Monthly Plan',
      dateRegistered: "May 16, 2024",
      lastActive: "May 16, 2024"
    },
    {
      id: 6,
      angelName: "Madison Lee",
      email: "madison@gmail.com",
      industry: ["E_COMMERCE_RETAIL"],
      startupStage: ["MVP", "SERIES_A"],
      plan: 'Monthly Plan',
      dateRegistered: "June 1, 2024",
      lastActive: "June 1, 2024"
    },
    {
      id: 7,
      angelName: "Dylan Prescott",
      email: "dylan@gmail.com",
      industry: ["CYBERSECURITY"],
      startupStage: ["SERIES_A", "MVP", "SERIES_B"],
      plan: 'Yearly Plan',
      dateRegistered: "April 17, 2024",
      lastActive: "April 17, 2024"
    },
    {
      id: 8,
      angelName: "Isabella Novak",
      email: "isabella@gmail.com",
      industry: ["GAMING_ENTERTAINMENT"],
      startupStage: ["SERIES_B",],
      plan: 'Monthly Plan',
      dateRegistered: "April 21, 2024",
      lastActive: "April 21, 2024"
    },
    {
      id: 9,
      angelName: "Marcus Bell",
      email: "marcus@gmail.com",
      industry: ["HEALTH_BIOTECH"],
      startupStage: ["PRE_SEED",],
      plan: 'Monthly Plan',
      dateRegistered: "April 29, 2024",
      lastActive: "April 29, 2024"
    },
    {
      id: 10,
      angelName: "Chloe Ramsey",
      email: "chloe@gmail.com",
      industry: ["AI_MACHINE_LEARNING"],
      startupStage: ["IDEA",],
      plan: 'Monthly Plan',
      dateRegistered: "July 13, 2024",
      lastActive: "July 13, 2024"
    }
  ],
  suspendedAngel: [
    {
      id: 1,
      angelName: "James Whitaker",
      email: "james@gmail.com",
      industry: ["AI_MACHINE_LEARNING", "SOCIAL_NETWORKING"],
      startupStage: ["IDEA","MVP","PRE_SEED"],
      plan: 'Yearly Plan',
      dateRegistered: "May 2, 2024",
      suspendedDate: "May 2, 2024"
    },
    {
      id: 2,
      angelName: "Olivia Hastings",
      email: "olivia@gmail.com",
      industry: ["SOCIAL_NETWORKING", "AI_MACHINE_LEARNING"],
      startupStage: ["MVP",],
      plan: 'Monthly Plan',
      dateRegistered: "May 3, 2024",
      suspendedDate: "May 3, 2024"
    },
    {
      id: 3,
      angelName: "Brandon Cole",
      email: "brandon@gmail.com",
      industry: ["CYBERSECURITY"],
      startupStage: ["MVP","PRE_SEED"],
      plan: 'Monthly Plan',
      dateRegistered: "April 29, 2024",
      suspendedDate: "April 29, 2024"
    },
    {
      id: 4,
      angelName: "Sophia Klein",
      email: "sophia@gmail.com",
      industry: ["AI_MACHINE_LEARNING", 'CYBERSECURITY'],
      startupStage: ["PRE_SEED",],
      plan: 'Yearly Plan',
      dateRegistered: "April 17, 2024",
      suspendedDate: "April 17, 2024"
    },
    {
      id: 5,
      angelName: "Ethan Morales",
      email: "ethan@gmail.com",
      industry: ["TRANSPORT_MOBILITY", "CYBERSECURITY", 'AI_MACHINE_LEARNING'],
      startupStage: ["IDEA",],
      plan: 'Monthly Plan',
      dateRegistered: "May 16, 2024",
      suspendedDate: "May 16, 2024"
    },
    {
      id: 6,
      angelName: "Madison Lee",
      email: "madison@gmail.com",
      industry: ["E_COMMERCE_RETAIL"],
      startupStage: ["MVP",],
      plan: 'Monthly Plan',
      dateRegistered: "June 1, 2024",
      suspendedDate: "June 1, 2024"
    },
    {
      id: 7,
      angelName: "Dylan Prescott",
      email: "dylan@gmail.com",
      industry: ["CYBERSECURITY"],
      startupStage: ["SERIES_A","MVP"],
      plan: 'Yearly Plan',
      dateRegistered: "April 17, 2024",
      suspendedDate: "April 17, 2024"
    },
    {
      id: 8,
      angelName: "Isabella Novak",
      email: "isabella@gmail.com",
      industry: ["GAMING_ENTERTAINMENT"],
      startupStage: ["SERIES_B",],
      plan: 'Monthly Plan',
      dateRegistered: "April 21, 2024",
      suspendedDate: "April 21, 2024"
    },
    {
      id: 9,
      angelName: "Marcus Bell",
      email: "marcus@gmail.com",
      industry: ["HEALTH_BIOTECH"],
      startupStage: ["PRE_SEED","SERIES_A","SERIES_B","MVP"],
      plan: 'Monthly Plan',
      dateRegistered: "April 29, 2024",
      suspendedDate: "April 29, 2024"
    },
    {
      id: 10,
      angelName: "Chloe Ramsey",
      email: "chloe@gmail.com",
      industry: ["AI_MACHINE_LEARNING"],
      startupStage: ["IDEA",],
      plan: 'Monthly Plan',
      dateRegistered: "July 13, 2024",
      suspendedDate: "July 13, 2024"
    }
  ],
  singleAngel: {
    id: 1,
    name: 'Tyler Grayson',
    jobTitle: 'Angel Investor',
    linkedinProfile: 'https://www.linkedin.com/tyler-grayson',
    bio: 'James is an angel investor and entrepreneur with more than 10 years of experience in the field of cyber security.Prior to turning investor, James co-founded Hyperwise Security that pioneered a groundbreaking CPU-Level detection technology, which was acquired by Check Point in 2/2015.Between 2015 – 2019, while with Check Point, James lead the advanced cyber security ideation process, and pioneered, researched and developed groundbreaking technologies, helping Check Point to deliver the most innovative security technologies to its customers. In addition to his architect role, James served as an expert advisor to Dr. Dorit Dor, the VP Products of Check Point, advising on various cyber security ideas and challenges.',
    startupInvested: 'Pontera, IONIX, Dealtable, Argon, Speedb',
    easySchedulingUrl: 'https://www.calendly.com/james-whitaker',
    industries: '🤖 🤖 AI & Machine Learning 🔒 🔒 Cybersecurity',
    startupStage: ['💡 IDEA MVP 🌱 PRE_SEED 🌿 SEED',],
    activity: {
      totalHours: '14.2',
      average: '21.4',
      activityList: [
        {
          name: 'Greg Anderson',
          time: '14.28'
        },
        {
          name: 'Joseph Brad',
          time: '14.23'
        },
        {
          name: 'Tyler Cohen',
          time: '14.54'
        },
        {
          name: 'James Madlin',
          time: '14.50'
        },
      ]
    },
    report: {
      reportList: [
        {
          reportNumber: 'Report #230',
          time: '14.58'
        },
        {
          reportNumber: 'Report #117',
          time: '14.58'
        },
      ]
    },
    adminHistory: [
      {
        reportNumber: 'Changed: Personal Email Address',
        time: '14.58'
      },
      {
        reportNumber: 'Changed: University Email Address',
        time: '14.52'
      },
      {
        reportNumber: 'Restored: Reason',
        time: '14.10'
      },
      {
        reportNumber: 'Suspended: Reason',
        time: '13.50'
      },
    ],
    billingDetail: [
      {
        status: 'Success',
        amount: '($130 USD)',
        duration: 'Month Day, Year'
      },
      {
        status: 'Failed',
        amount: '($130 USD)',
        duration: 'Month Day, Year'
      },
      {
        status: 'Refund',
        amount: '($130 USD)',
        duration: 'Month Day, Year'
      },
    ]
  },
};

const activeSlice = createSlice({
  name: 'angels',
  initialState,
  reducers: {
    setActiveAngels: (state, action) => {
      state.activeAngel = action.payload;
    },
    setNotCompletedAngel: (state, action) => {
      state.notCompletedAngel = action.payload;
    },
    setSuspendActive: (state, action) => {
      state.suspendedAngel = action.payload;
    },
    setSingleActive: (state, action) => {
      state.singleAngel = action.payload;
    },
  },
});

export const {
  setActiveAngels,
  setNotCompletedAngel,
  setSuspendActive,
  setSingleActive
} = activeSlice.actions;

export default activeSlice.reducer;
